import axios from "axios";
import apiSwiftboard from "api/global-api/api-swiftboard";

/**
 * Upload single file to S3 with progress + cancel support
 */
export const uploadSingleFile = async ({
  file,
  directory,
  projectTitle,
  onProgress,
  onSpeed,
  cancelTokenSource,
}) => {
  try {
    // 1️⃣ Get presigned URL
    const payload = {
      directory,
      projectTitle,
      contentType: file.type || "application/octet-stream",
    };

    const response = await apiSwiftboard.getPresignedUrl(payload)
    const { url } = response.data.data;

    const startTime = Date.now();

    // 2️⃣ Upload to S3
    await axios.put(url, file, {
      headers: {
        "Content-Type": file.type || "application/octet-stream",
      },
      cancelToken: cancelTokenSource?.token,
      onUploadProgress: (progressEvent) => {
        const loaded = progressEvent.loaded;
        const total = progressEvent.total;

        const percent = Math.round((loaded * 100) / total);

        if (onProgress) onProgress(percent);

        // 🔥 Speed Calculation
        const timeElapsed = (Date.now() - startTime) / 1000;
        const speedMbps =
          timeElapsed > 0
            ? ((loaded * 8) / (1024 * 1024)) / timeElapsed
            : 0;

        if (onSpeed) onSpeed(speedMbps.toFixed(2));
      },
    });

    // Remove query params from presigned URL
    const fileUrl = url.split("?")[0];

    return {
      success: true,
      file_url: fileUrl,
    };
  } catch (error) {
    if (axios.isCancel(error)) {
      return { success: false, cancelled: true };
    }
    return { success: false, error };
  }
};